import { render, staticRenderFns } from "./IletisimListesi.vue?vue&type=template&id=73c254c8&scoped=true&"
import script from "./IletisimListesi.vue?vue&type=script&lang=js&"
export * from "./IletisimListesi.vue?vue&type=script&lang=js&"
import style0 from "./IletisimListesi.vue?vue&type=style&index=0&id=73c254c8&lang=scss&scoped=true&"
import style1 from "./IletisimListesi.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c254c8",
  null
  
)

export default component.exports